import * as React from 'react';
import * as FunctionFile from '../../FunctionFile';

class ReadEnvoyMessageProps {
    username: string;
    pickupUrl: string;
    isSender: boolean;
}

class ReadEnvoyMessageState {
}

export default class ReadEnvoyMessage extends React.Component<ReadEnvoyMessageProps, ReadEnvoyMessageState> {

    render() {

        var senderControls: JSX.Element;

        if (this.props.isSender) {
            senderControls = <div className="sender-controls">
                    <h3 className="ms-font-xl">Sender Controls</h3>
                    <p>You can view the <strong>Proof of Delivery Log</strong> or <strong>Revoke access</strong> after opening the encrypted email, above.</p>                    
                </div>;
        }

        return <div className="ReadEnvoyMessage">
                <a target="_blank" className="ms-Button ms-Button--primary" href={this.props.pickupUrl} onClick={(e) => { e.preventDefault(); FunctionFile.showDialog(this.props.pickupUrl)}}>
                    <span className="ms-Button-label">Open Encrypted Email</span>
                </a>

                {senderControls}
            </div>;
    }
}



// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/tasks/ReadMessage/ReadEnvoyMessage.tsx